import { cloneElement, useRef } from "react";

/**
 * Resize handle
 *
 * @param {object} props
 */
export default function DragEdge({
  children,
  vertical,
  dragging,
  onResize,
  parent,
}) {
  const ref = useRef();
  let pos1 = 0;
  let pos2 = 0;
  let change;
  function onMouseDown(e) {
    e = e || window.event;
    e.preventDefault();
    // get the mouse cursor position at startup:
    let el;
    if (Array.isArray(parent)) {
      el = parent[0].current;
    } else {
      el = parent.current;
    }
    pos1 = vertical ? el.offsetHeight : el.offsetWidth;
    pos2 = vertical ? e.clientY : e.clientX;
    el.ownerDocument.onmouseup = closeDragElement;
    // call a function whenever the cursor moves:
    el.ownerDocument.onmousemove = elementDrag;
    dragging(true);
  }
  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    // calculate the new cursor position:
    const pos3 = vertical ? e.clientY : e.clientX;
    change = pos1 - pos2 + pos3;
    // set the element's new position:
    if (Array.isArray(parent)) {
      parent.forEach(
        (e) => (e.current.style[vertical ? "height" : "width"] = change + "px")
      );
    } else {
      parent.current.style[vertical ? "height" : "width"] = change + "px";
    }
    e.target.ownerDocument.body.style.cursor = vertical
      ? "row-resize"
      : "col-resize";
  }
  function closeDragElement(e) {
    ref.current.ownerDocument.defaultView.lastMouseRelease = e.timeStamp;
    // stop moving when mouse button is released:
    ref.current.ownerDocument.onmouseup = null;
    ref.current.ownerDocument.onmousemove = null;
    e.target.ownerDocument.body.style.cursor = null;
    onResize({ [vertical ? "height" : "width"]: change });
  }
  return cloneElement(children, { onMouseDown, ref });
}
